import { useCallback, useState } from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ButtonWithFontAwesome from '@monorepo/shared/src/components/common/Buttons/ButtonWithFontAwesome';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { FONT_GSS_FUTURA_BOOK } from '@monorepo/shared/src/themes/defaultTheme';
import Config from '@monorepo/shared/src/config';
import SSOLogoutFrame from '@monorepo/shared/src/components/common/SSOLogoutFrame';
import { maybe } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/maybe-util';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

const t = (key: string, options?) => translate('modal', key, options);

const ExpiredModal = () => {
  const classes = useStyles();

  const goToPurchaseLicense = useCallback(async () => {
    const { companyUrl } = Config;
    window.location.replace(companyUrl);
  }, []);

  const [hasLoggedOut, setHasLoggedOut] = useState(false);

  const handleLogout = (event: any) => {
    setHasLoggedOut(true);
    event.stopPropagation();
  };

  const MaybeSSOLogout: any = maybe(SSOLogoutFrame);

  const getSrc = (uri) => `${Config.digitalAssetsUrl}${uri}`;

  return (
    <Box className={classes.modal}>
      <Box style={{ textAlign: 'center', padding: '60px 32px 24px' }}>
        <img className={classes.img} src={getSrc('/modals/images/mmaz-license-expired.png')} />
        <Box style={{ textAlign: 'left', paddingTop: '30px' }}>
          <Typography className={classes.text}>{t('expiredExplanation')}:</Typography>
          <ul className={classes.list}>
            <li>
              <Typography className={classes.text}>{t('expiredLicensesFeature1')}</Typography>
            </li>
            <li>
              <Typography className={classes.text}>{t('expiredLicensesFeature2')}</Typography>
            </li>
            <li>
              <Typography className={classes.text}>{t('expiredLicensesFeature3')}</Typography>
            </li>
            <li>
              <Typography className={classes.text}>{t('expiredLicensesFeature4')}</Typography>
            </li>
          </ul>
        </Box>
        <Box sx={{ paddingTop: '30px', display: 'flex', flexDirection: 'row' }}>
          <Box
            sx={{
              marginRight: 'auto',
            }}
          >
            <ButtonWithFontAwesome
              onClick={handleLogout}
              startIcon={faSignOutAlt}
              text={t('logout')}
              aria-label={t('logout')}
              variant="text"
              className={classes.logoutButton}
            />
            <MaybeSSOLogout shouldRender={hasLoggedOut} />
          </Box>
          <Box
            sx={{
              marginLeft: 'auto',
            }}
          >
            <ButtonWithFontAwesome
              onClick={goToPurchaseLicense}
              text={t('purchaseLicense')}
              aria-label={t('purchaseLicense')}
              variant="contained"
              color="primary"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    flex: 1,
    backgroundColor: 'white',
    width: '600px',
    justifyContent: 'center',
  },
  img: {
    height: '250px',
    width: '450px',
  },
  list: {
    paddingLeft: 15,
  },
  text: {
    fontFamily: FONT_GSS_FUTURA_BOOK,
    fontSize: '16px',
    lineHeight: '24px',
    marginBottom: '2px',
  },
  logoutButton: {
    ...theme.typography.caption,
    padding: '6px 16px 6px 16px',
    color: 'black',
    justifyContent: 'left',
  },
}));

export default ExpiredModal;
